export const LOAD_TASKS = 'TASKS/LOAD';
